import React, { useState } from "react";
import "../../Assets/Css/DiagnosticPopup.css";
import CalendarIcon from "../../Assets/Images/SVG/testlog-calendar.svg";
import CameraIcon from "../../Assets/Images/CameraIcon.png";
import CloseIcon from "../../Assets/Images/SVG/cross1.svg";
import SaveTickIcon from "../../Assets/Images/SVG/SaveTick.svg";
import CameraComponent from "../CameraComponent/CameraComponent"; // Assuming the camera component is already set up

const DiagnosticPopup = ({ onClose }) => {
  const [showCamera, setShowCamera] = useState(false);
  const [capturedImage, setCapturedImage] = useState(null);

  const handleCapture = (image) => {
    setCapturedImage(image); // Save the captured image
    setShowCamera(false); // Close the camera
  };

  const handleDeleteClick = () => {
    setCapturedImage(null); // Remove the captured image
  };

  const handleSaveClick = () => {
    // You can add any logic here to save the data if needed
    onClose(); // Close the popup
  };

  return (
    <div className="diagnostic-popup-overlay">
      {showCamera ? (
        <CameraComponent
          onClose={() => setShowCamera(false)}
          onCapture={handleCapture}
        />
      ) : (
        <div className="diagnostic-popup-container">
          <img
            src={CloseIcon}
            alt="Close"
            className="dpclose-icon"
            onClick={onClose}
          />
          <h3 className="dppopup-title">Diagnostics</h3>

          <div className="dppopup-content">
            <label htmlFor="diagnostic-date">Date</label>
            <div className="input-with-icon">
              <input
                type="text"
                id="diagnostic-date"
                defaultValue="20/07/2024"
                readOnly
              />
              <img
                src={CalendarIcon}
                alt="Calendar"
                className="dpcalendar-icon"
              />
            </div>

            <div className="dpseparator">
              <div className="dpline"></div>
              <span>or</span>
              <div className="dpline"></div>
            </div>

            {/* Show the upload button if no image is captured */}
            {!capturedImage && (
              <button
                className="dpupload-button"
                onClick={() => setShowCamera(true)}
              >
                <p className="dpupload-para">Upload photo</p>
                <img src={CameraIcon} alt="Camera" className="dpcamera-icon" />
              </button>
            )}

            {/* Show captured image layout if an image is captured */}
            {capturedImage && (
              <div className="cmedicine-info">
                <img
                  src={capturedImage}
                  alt="Captured"
                  className="cmedicine-image"
                />
                <span>Captured Image</span>
                <button className="cdelete-button" onClick={handleDeleteClick}>
                  ×
                </button>
              </div>
            )}
          </div>

          <button className="dpsave-button" onClick={handleSaveClick}>
            <img src={SaveTickIcon} alt="Save" className="dpsave-icon" />
            Save
          </button>
        </div>
      )}
    </div>
  );
};

export default DiagnosticPopup;
